import React from "react";
import { Bounce, cssTransition } from "react-toastify";

export const CART_ADD_TOAST_KIND = "cart-add";

const MOBILE_CART_QUERY = "(max-width: 768px)";

const MobileCartMorphTransition = cssTransition({
  enter: "cart-toast-morph-enter",
  exit: "cart-toast-morph-exit",
  appendPosition: false,
  collapse: true,
  collapseDuration: 180,
});

const isMobileCartMenu = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const isMobile = Boolean(window.matchMedia?.(MOBILE_CART_QUERY)?.matches);
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";

  return isMobile && pathname === "/cardapio";
};

export function CartToastTransition(props) {
  const Transition = isMobileCartMenu() ? MobileCartMorphTransition : Bounce;
  return React.createElement(Transition, props);
}

export const isCartAddToast = (toastItem) =>
  toastItem?.data?.kind === CART_ADD_TOAST_KIND;
